// extracted by mini-css-extract-plugin
export default {"developmentOptions":"FWYXAKZ4gZuINTkyvnim","developmentOptionsItem":"moIn5zCPFQd_qjkSnGZs"};